import type { ReactNode } from "react";

export function PageIntro({
  eyebrow,
  title,
  description,
  aside,
  details = ["Claro", "Práctico", "Digital"],
  compact = false,
}: {
  eyebrow: string;
  title: ReactNode;
  description?: ReactNode;
  aside?: ReactNode;
  details?: [string, string, string];
  compact?: boolean;
}) {
  return (
    <section className="border-b border-black/10 bg-white">
      <div className="mx-auto grid max-w-7xl md:grid-cols-[1.25fr_0.75fr]">
        <div
          className={`flex items-center px-4 sm:px-6 ${
            compact ? "min-h-48 py-10 sm:py-12 lg:min-h-52" : "min-h-64 py-14 sm:py-16 lg:min-h-72"
          }`}
        >
          <div className="min-w-0 max-w-3xl">
            <p className="text-xs font-semibold uppercase tracking-[0.18em] text-black/70">
              {eyebrow}
            </p>
            <h1 className="mt-4 text-4xl font-semibold leading-[1.05] tracking-[-0.05em] sm:text-5xl">
              {title}
            </h1>
            {description && (
              <p className="mt-4 max-w-xl text-sm leading-6 text-black/75">{description}</p>
            )}
          </div>
        </div>

        <div
          className={`flex flex-col justify-between bg-black p-6 text-white sm:p-8 md:min-h-full ${
            compact ? "min-h-40" : "min-h-52"
          }`}
        >
          <div className="flex items-center justify-between text-xs font-medium uppercase tracking-[0.16em] text-white/75">
            <span>Socrattica</span>
            <span>{eyebrow}</span>
          </div>

          {aside ? (
            <div className={compact ? "my-5" : "my-8"}>{aside}</div>
          ) : (
            <p
              className={`max-w-xs font-semibold leading-tight tracking-[-0.04em] ${
                compact ? "my-5 text-xl" : "my-8 text-2xl"
              }`}
            >
              Aprende sin ruido.
            </p>
          )}

          <div className="grid grid-cols-3 border-y border-white/20 py-4 text-center">
            {details.map((detail) => (
              <span key={detail} className="text-xs uppercase tracking-[0.12em] text-white/75">
                {detail}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
